import { Text } from '@change/ds-core-ui';

export const ShareSectionHeading: React.FC<EmptyProps> = () => (
	<div className="flex flex-col gap-1 text-start">
		<Text
			as="h3"
			variant="heading"
			size="small"
			className="m-0"
			data-qa="promote-share-heading"
			data-testid="promote-share-heading"
		>
			{/* TODO: Add translation when productized */}
			Grow support by sharing
		</Text>
		<Text
			className="text-typography-strong md:text-lg"
			data-qa="promote-share-subheading"
			data-testid="promote-share-subheading"
		>
			{/* TODO: Add translation when productized */}
			Each share helps this petition reach potential signers. Take 2 min to help it succeed.
		</Text>
	</div>
);
